export default __webpack_public_path__ + "static/screeny-130-ga-2-fa96c62cc95d9037394285dd978fa556.jpg";